!<!--  -->
<template>
    <div class='card'>
        <p style="margin-bottom:30px;font-size:30px;font-weight:700">{{title}}</p>
        <slot></slot>
    </div>
</template>

<script>

export default {
//import引入的组件需要注入到对象中才能使用
components: {},
props:{
    title:{type:String,default:`title=''属性设置名称`}
},
data() {
//这里存放数据
return {

};
},
//监听属性 类似于data概念
computed: {},
//监控data中的数据变化
watch: {},
//方法集合
methods: {

},
//生命周期 - 创建完成（可以访问当前this实例）
created() {

},
//生命周期 - 挂载完成（可以访问DOM元素）
mounted() {

},
}
</script>
<style  scoped>

.card{
    padding: 30px;
    background: rgb(255, 255, 255);
    box-shadow: rgb(107 105 105 / 21%) 0px 0px 20px 0px;
    border-radius: 10px;
}
</style>


// WEBPACK FOOTER //
// src/components/QuotationManagement/jack-components/wrap-card.vue